<template>
  <div>
    <b-card>
      <div slot="header">
        <b-row>
          <b-col class="text-left">
            <strong v-text="`${$lang.reports_for} ${personName}`" />
          </b-col>
          <b-col class="text-right">
            <b-button
              class="btn-lightgray ml-2"
              v-b-tooltip.hover
              :title="$lang.list_updating"
              @click="fetchData"
            >
              <mdicon name="refresh" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col cols="12" md="12" class="my-2">
          <LoadingSpinner :loading="loading" />
        </b-col>
        <b-col cols="12" md="12">
          <div class="table-responsive mb-5" v-if="!loading && items.length">
            <table
              stickycolumn="true"
              role="table"
              class="washup-table table b-table table-bordered text-center table-hover align-middle"
            >
              <thead role="rowgroup" class="text-center">
                <tr role="row">
                  <th class="empty position-relative p-3 text-center">
                    <span class="w-100" v-text="$lang.report_name" />
                  </th>
                  <th class="empty position-relative p-3 text-center">
                    <span class="w-100" v-text="$lang.resource_report" />
                  </th>
                  <th class="empty position-relative p-3 text-center">
                    <span class="w-100" v-text="$lang.created_at" />
                  </th>
                  <th class="empty position-relative p-3 text-center">
                    <span class="w-100" v-text="$lang.format" />
                  </th>
                  <th class="empty position-relative p-3 text-center">
                    <span class="w-100" v-text="$lang.operation" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                  <td class="text-left text-dark">
                    <span
                      class="ml-2"
                      v-text="pathOr('', ['report_caption'], item)"
                    />
                  </td>
                  <td class="text-center text-dark">
                    <span
                      class="ml-2"
                      v-text="
                        `${pathOr(
                          '',
                          ['resource', 'caption'],
                          item
                        )} شماره ${pathOr('', ['resource', 'id'], item)}`
                      "
                    />
                  </td>
                  <td class="text-center text-dark">
                    <span
                      class="ml-2"
                      v-text="pathOr('', ['created_at', 'jalali'], item)"
                    />
                  </td>
                  <td class="text-center text-dark">
                    <span class="ml-2" v-text="pathOr('', ['format'], item)" />
                  </td>

                  <td
                    class="text-center text-dark d-flex align-items-center justify-content-between"
                  >
                    <router-link
                      v-if="
                        pathOr('', ['request_type'], item) === 'service' &&
                        checkFrontPageName(item)
                      "
                      :to="generateReportRoute(item)"
                      target="_blank"
                    >
                      <span class="cursor_pointer text-primary">
                        <mdicon
                          v-if="pathOr(null, ['format'], item) === 'xls'"
                          name="file-excel"
                          size="20"
                        />
                        <mdicon
                          v-if="pathOr(null, ['format'], item) === 'html'"
                          name="language-html5"
                          size="20"
                        />
                        <mdicon
                          v-if="pathOr(null, ['format'], item) === 'pdf'"
                          name="file-pdf-box"
                          size="20"
                        />
                        <span v-text="$lang.report_show" class="ml-1" />
                      </span>
                    </router-link>
                    <span v-else>&nbsp;</span>
                    <b-button
                      v-if="pathOr(null, ['request_type'], item) === 'file'"
                      variant="link"
                      @click="downloadFile(item)"
                      class="d-flex"
                    >
                      <span class="d-flex">
                        <mdicon
                          v-if="
                            downloadLoading.findLast(
                              (row) => row === item.download_code
                            )
                          "
                          name="loading"
                          class="spinner"
                        />
                        <mdicon
                          v-else
                          name="cloud-download-outline"
                          size="20"
                        />
                      </span>
                      <span v-text="$lang.received_report" class="ml-1" />
                    </b-button>
                    <b-button
                      v-if="
                        pathOr(0, ['is_manual'], item) === 1 &&
                        isAdmin(permissions, ['admin'])
                      "
                      variant="danger"
                      size="sm"
                      @click="showDeleteConfirm(item)"
                    >
                      <mdicon name="delete-outline" size="20" />
                      {{ $lang.delete }}
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col v-if="!loading && !items.length" cols="12" md="12">
          <b-alert
            show
            variant="danger"
            v-text="$lang.notExistParvandehInfoMessage"
          />
        </b-col>
      </b-row>
      <div class="float-right mt-3">
        <b-button variant="outline-danger" @click="close">
          <mdicon name="close" size="20" />
          {{ $lang.close }}
        </b-button>
      </div>
    </b-card>
    <Confirm
      v-model="confirmData.show"
      :ok-title="$lang.yes"
      :title="$lang.delete"
      :description="$lang.are_you_sure_delete"
      :cancel-title="$lang.no"
      :loading="confirmData.loading"
      dynamicClass=""
      @ok="deleteReport"
      @cancel="closeDeleteConfirm"
    />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Confirm from "@/components/base/confirm";
import { pathOr, includes } from "ramda";
import {
  generateApiUrl,
  checkFrontPageName,
  isAdmin,
  removeItemInArray,
} from "@/shared/utils";
import { getAttachmentDownloadFile } from "@/services";

export default {
  components: {
    LoadingSpinner,
    Confirm,
  },
  props: {
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
    resource: {
      type: String,
      default: null,
    },
    resourceCode: {
      type: [String, Number],
      default: null,
    },
    saltFileName: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      items: [],
      permissions: [],
      confirmData: {
        show: false,
        loading: false,
        item: null,
      },
      downloadLoading: [],
    };
  },
  computed: {
    personName() {
      return pathOr("", ["0", "parvandeh", "full_name"], this.items);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    checkFrontPageName,
    isAdmin,
    close() {
      this.$emit("close");
    },
    async fetchData() {
      try {
        this.loading = true;
        const queryString =
          this.resource && this.resourceCode
            ? { resource: this.resource, resource_id: this.resourceCode }
            : {};
        const url = generateApiUrl(
          ["profile", "parvandeh_report"],
          [this.parvandehCode],
          queryString
        );
        const response = await this.$httpService.get(url);
        this.items = pathOr([], ["data", "data"], response);
        this.permissions = pathOr([], ["data", "permissions"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    showDeleteConfirm(item) {
      this.confirmData.item = item;
      this.confirmData.show = true;
    },
    closeDeleteConfirm() {
      this.confirmData.item = null;
      this.confirmData.show = false;
    },
    async deleteReport() {
      try {
        this.confirmData.loading = true;
        const id = pathOr(null, ["report_detail_id"], this.confirmData.item);
        const url = generateApiUrl(["resources", "report_id"], [id]);
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.closeDeleteConfirm();
        await this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    async downloadFile(item) {
      const downloadCode = pathOr(null, ["download_code"], item);
      const downloadFileName = pathOr(null, ["download_file_name"], item);
      if (!downloadCode) return;
      try {
        this.downloadLoading.push(downloadCode);
        await getAttachmentDownloadFile(downloadCode, downloadFileName);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.downloadLoading = removeItemInArray(
          downloadCode,
          this.downloadLoading
        );
      }
    },
    generateReportRoute(item) {
      const resource = pathOr(null, ["resource", "name"], item);
      const resourceCode = pathOr(null, ["resource", "code"], item);
      const isCenterExecute = resource === "center_execute";
      return {
        name: `${pathOr(null, ["front_page_name"], item)}-report`,
        params: {
          parvandehCode: pathOr(null, ["parvandeh", "code"], item),
          examPackId: pathOr(null, ["exam_pack", "id"], item), // use in azmoon module
          resourceCode: isCenterExecute
            ? resourceCode // use in kanoon module
            : pathOr(null, ["azmoon_execute_person_code"], item), // use in azmoon module
        },
      };
    },
  },
};
</script>
